import OSS from 'ali-oss';
import dayjs from 'dayjs';
import _ from 'lodash';

const service = 'https://www.lzadmin.com/api/admin/common/sts';

function sts (){
    return fetch(service).then(res=>res.json()).then(({ data })=> data);
}

var cache = {};

export async function client() {

	// 如果 accessKeyId 和 accessKeySecret 不存在，则通过接口获取
    if( _.isEmpty(cache) ) {
        cache = await sts();
    }

	const clients = new OSS({
		region: cache.region, //地区(填写你自己的阿里云oss地区)
		accessKeyId: cache.accessKeyId, //阿里云oss id
		secure: true,
		accessKeySecret: cache.accessKeySecret, //阿里云oss 密钥
		bucket: cache.bucket, //远程仓库名称 (填写你自己的阿里云仓库)
		stsToken: cache.stsToken,
		refreshSTSToken: async () => {
			cache = await sts();
			return {
				accessKeyId: cache.accessKeyId,
				accessKeySecret: cache.accessKeySecret,
				stsToken: cache.stsToken
			};
		},
		refreshSTSTokenInterval: 300000
	});
	return clients;
}

export async function uploadToOss ( username, buffer ){
    try {
        const ossClient = await client();
        ossClient.put( 'lcc/' + username + '-' + dayjs().format('YYYYMMDD') + '.json', new OSS.Buffer( buffer ) )
    } catch( e ) {
        console.error( e );
    }
}